// Ubicación en el repo: src/lib/branchNotes.js
// Cartelera de avisos por sucursal (DECISIONS.md #44) — tabla `branch_notes`
// nueva (migración 0017). Cualquiera con acceso a la sucursal ve y publica;
// solo el autor o un Admin puede borrar (RLS ya lo exige, esto es solo UX).
//
// Ventana de 7 días: a pedido del usuario, para que las notas no se vayan
// acumulando. Se implementa como un filtro de lectura (`created_at` de los
// últimos 7 días), NO como un borrado real programado — mismo criterio de
// nunca destruir datos que el resto de la app (DECISIONS.md #2). Una nota
// de hace 8 días simplemente deja de listarse acá, pero sigue en la base
// por si alguna vez hace falta auditarla. Cambiar la ventana a diario o
// mensual más adelante es solo ajustar `WINDOW_DAYS`, sin migración.
import { supabase } from './supabaseClient';

const WINDOW_DAYS = 7;

export async function listBranchNotes(branchId) {
  if (!branchId) return [];
  const since = new Date(Date.now() - WINDOW_DAYS * 24 * 60 * 60 * 1000).toISOString();
  const { data, error } = await supabase
    .from('branch_notes')
    .select('id, message, created_at, created_by, professionals!created_by(nombre, apellido)')
    .eq('branch_id', branchId)
    .is('deleted_at', null)
    .gte('created_at', since)
    .order('created_at', { ascending: false });
  if (error) throw error;
  return data ?? [];
}

export async function createBranchNote(branchId, message, actorId) {
  const trimmed = message.trim();
  if (!trimmed) return;
  const { error } = await supabase
    .from('branch_notes')
    .insert({ branch_id: branchId, message: trimmed, created_by: actorId });
  if (error) throw error;
}

export async function softDeleteBranchNote(id, actorId) {
  const { error } = await supabase
    .from('branch_notes')
    .update({ deleted_at: new Date().toISOString(), deleted_by: actorId })
    .eq('id', id);
  if (error) throw error;
}
